import { Controller } from "@hotwired/stimulus"
import { formatPln, getJSON } from "../api.js"

// Pulpit KPI klientów: karty totals + tabela klientów z GET /api/staff/clients/kpi/ (tylko personel).
export default class extends Controller {
  static targets = ["status", "clients", "activeClients", "revenue", "leadsSold", "rows", "rowTemplate"]
  static values = { url: String } // /api/staff/clients/kpi/

  connect() { this.load() }

  async load() {
    let data
    try {
      data = await getJSON(this.urlValue)
    } catch {
      this.#status("Nie udało się załadować danych. Odśwież stronę.")
      return
    }
    this.#status(null)

    const { totals, clients } = data
    this.clientsTarget.textContent = totals.clients
    this.activeClientsTarget.textContent = totals.active_clients
    this.revenueTarget.textContent = formatPln(totals.revenue_pln)
    this.leadsSoldTarget.textContent = totals.leads_sold

    this.#renderRows(clients)
  }

  // XSS-safe: klonujemy <template> i wypełniamy przez textContent (żadnego innerHTML z danych).
  #renderRows(clients) {
    this.rowsTarget.replaceChildren()
    for (const client of clients) {
      const row = this.rowTemplateTarget.content.firstElementChild.cloneNode(true)
      row.querySelector('[data-field="name"]').textContent = client.name
      row.querySelector('[data-field="orders"]').textContent = client.orders
      row.querySelector('[data-field="revenue"]').textContent = formatPln(client.revenue_pln)
      row.querySelector('[data-field="leads"]').textContent = client.leads
      this.rowsTarget.append(row)
    }
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
